export interface LightingConfig {
  sunAzimuthDeg: number;
  sunElevationDeg: number;
  sunColor: number;
  sunIntensity: number;
  hemisphereSkyColor: number;
  hemisphereGroundColor: number;
  hemisphereIntensity: number;
  /** Half-extent (world units) of the sun's orthographic shadow frustum. */
  shadowFrustumSize: number;
}

export const DEFAULT_LIGHTING_CONFIG: LightingConfig = {
  sunAzimuthDeg: 235,
  sunElevationDeg: 52,
  sunColor: 0xfff2e0,
  sunIntensity: 3.2,
  hemisphereSkyColor: 0xbfd7ff,
  hemisphereGroundColor: 0x2b3a1f,
  hemisphereIntensity: 0.6,
  shadowFrustumSize: 80,
};
